window.addEventListener('load', function () {
  const body = document.body;
  body.classList.add('fade-in');
})


document.addEventListener('DOMContentLoaded', () => {

  const body1 = document.body;
  body1.classList.add('fade-in');

// Menu button
  const body = document.body;
  const mobileMenu = document.querySelector('#mobile-menu');
  const burger = document.querySelector('#menu-button');

  mobileMenu.addEventListener('click', event => {
    closeMobileMenu()
  });

  if (burger) {
    burger.addEventListener('click', (event) => {
      const isToggled = burger.classList.contains('toggled');
      if (isToggled) {
       closeMobileMenu()
      } else {
        burger.classList.add('toggled');
        mobileMenu.classList.add('toggled');
        body.classList.add('mobile-menu-open');
      }
      event.preventDefault();
    });
  }
  let lastWidth = window.innerWidth;
  window.onresize = function(e) {
    if (lastWidth != window.innerWidth) {
      closeMobileMenu()
    }
  }

  function closeMobileMenu() {
    burger.classList.remove('toggled');
    mobileMenu.classList.remove('toggled');
    body.classList.remove('mobile-menu-open');
  }
});